// Getters
export const DIGITAL_FRANCHISES_SEARCH_RESULT =
  "franchises/DIGITAL_FRANCHISES_SEARCH_RESULT";
export const PHYSICAL_FRANCHISES_SEARCH_RESULT =
  "franchises/PHYSICAL_FRANCHISES_SEARCH_RESULT";
export const NEW_FRANCHISE_SIDEBAR = "franchises/NEW_FRANCHISE_SIDEBAR";
export const NEW_PHYSICAL_FRANCHISE_SIDEBAR =
  "franchises/NEW_PHYSICAL_FRANCHISE_SIDEBAR";
export const DIGITAL_TABLE_COLUMNS = "franchises/DIGITAL_TABLE_COLUMNS";
export const PHYSICAL_TABLE_COLUMNS = "franchises/PHYSICAL_TABLE_COLUMNS";
export const DIGITAL_FRANCHISE_PURCHASE_SIDEBAR = 'consultant/DIGITAL_FRANCHISE_PURCHASE_SIDEBAR'
export const DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES = 'consultant/DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES'
export const DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS = 'consultant/DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS'
export const DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT = 'consultant/DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT'

// Mutations
export const MUTATE_DIGITAL_FRANCHISES_RESULT =
  "franchises/MUTATE_DIGITAL_FRANCHISES_RESULT";
export const MUTATE_PHYSICAL_FRANCHISES_RESULT =
  "franchises/MUTATE_PHYSICAL_FRANCHISES_RESULT";
export const MUTATE_NEW_FRANCHISE_SIDEBAR =
  "franchises/MUTATE_NEW_FRANCHISE_SIDEBAR";
export const MUTATE_NEW_PHYSICAL_FRANCHISE_SIDEBAR =
  "franchises/MUTATE_NEW_PHYSICAL_FRANCHISE_SIDEBAR";
export const MUTATE_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR = 'consultant/MUTATE_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR'
export const MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES = 'consultant/MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES'
export const MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS = 'consultant/MUTATE_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS'
export const MUTATE_DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT = 'consultant/MUTATE_DIGITAL_FRANCHISES_PURCHASE_SEARCH_RESULT'

// Actions
export const GET_DIGITAL_FRANCHISE = "franchises/GET_DIGITAL_FRANCHISE";
export const GET_PHYSICAL_FRANCHISE = "franchises/GET_PHYSICAL_FRANCHISE";
export const SEARCH_DIGITAL_FRANCHISES = "franchises/SEARCH_DIGITAL_FRANCHISES";
export const SEARCH_PHYSICAL_FRANCHISES =
  "franchises/SEARCH_PHYSICAL_FRANCHISES";
export const OPEN_NEW_FRANCHISE_SIDEBAR =
  "franchises/OPEN_NEW_FRANCHISE_SIDEBAR";
export const OPEN_NEW_PHYSICAL_FRANCHISE_SIDEBAR =
  "franchises/OPEN_NEW_PHYSICAL_FRANCHISE_SIDEBAR";
export const STORE_FRANCHISE = "franchises/STORE_FRANCHISE";
export const EDIT_FRANCHISE = "franchises/EDIT_FRANCHISE";
export const STORE_PHYSICAL_FRANCHISE = "franchises/STORE_PHYSICAL_FRANCHISE";
export const EDIT_PHYSICAL_FRANCHISE = "franchises/EDIT_PHYSICAL_FRANCHISE";
export const OPEN_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR = 'consultant/OPEN_DIGITAL_FRANCHISE_PURCHASE_SIDEBAR'
export const GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES = 'consultant/GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_TYPES'
export const GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS = 'consultant/GET_DIGITAL_FRANCHISE_PURCHASE_FRANCHISE_STATUS'
export const SAVE_DIGITAL_FRANCHISE_PURCHASE = 'consultant/SAVE_DIGITAL_FRANCHISE_PURCHASE'
export const SEARCH_DIGITAL_FRANCHISES_PURCHASE = 'consultant/SEARCH_DIGITAL_FRANCHISES_PURCHASE'
export const GET_DIGITAL_FRANCHISE_PURCHASE = 'consultant/GET_DIGITAL_FRANCHISE_PURCHASE'
export const UPDATE_DIGITAL_FRANCHISE_PURCHASE = 'consultant/UPDATE_DIGITAL_FRANCHISE_PURCHASE'